import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import * as MyAccountActions from '../actions/MyAccountActions'
import * as Fetch from '../util/Fetch'
import { glasConfig } from '../constants/Config'
import * as FileActions from '../actions/FileActions'
import SettingMenu from './SettingMenu'
import TextField from 'material-ui/TextField'
import * as SettingContractAction from '../actions/SettingContactAction'
import * as moment from 'moment'
class SettingContract extends Component {
	constructor(props) {
		super(props)
		this.state = {
			datas: []
		}
	}
	componentWillMount() {
		const { dispatch } = this.props
		dispatch(SettingContractAction.getAllContractAction())
		dispatch(MyAccountActions.fetch())
	}

	render() {
		const { SettingContractTerm, MyProfile } = this.props
		return (
			<>
			 <style>
				{`
				h4 {
					color : rgba(0, 0, 0, 0.54);
				}
				.removeDot {
					list-style-type: none;
					padding-left: 20px;
				}
				li {
					margin-bottom: 5px;
				}
				.startworkingtime{

						display: block;
						padding: 0;
						margin: 0 0 16px;
						background: #fff;
						border-radius: 2px;
						box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.24);
					}
				`}
				
			</style>
			<div className="content">
				<h1 className="content__title">設定</h1>
				<SettingMenu />
				<div className="primary">
					<div className="primary__inner" dangerouslySetInnerHTML={{ __html: SettingContractTerm.data }}>
					</div>
				</div>
				<div className='startworkingtime'>
					<div className="primary__inner">
					<p className='definition__title' >委託開始日 </p>
					<p>
					{MyProfile.data.startWorkingTime ?
						moment(MyProfile.data.startWorkingTime).format('YYYY/MM/DD')
														: '-'
					}
					</p>
					</div>
				</div>
			</div>
			
			</>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		SettingContractTerm: state.SettingContractTerm,
		MyProfile: state.MyProfile,
	}
}

export default connect(mapStateToProps)(SettingContract)
